import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shorten'
})
export class ShortenPipe implements PipeTransform {
    transform(value: string, maxCharacterLength: number = 10): string {
        if (value.length > maxCharacterLength) {
            let result = value.substr(0, maxCharacterLength).trim();
            result = result.replace(/[^a-zA-ZА-Яа-я0-9_]+$/, '');
            return result + '...';
        }
        return value;
    }
}
